import React, { useCallback, useMemo, useState } from 'react';
import { PartesRepresentadasProps } from '../types';
import { IconTrash } from '../../../icons';
import {
  Label,
  Input,
  AddButton,
  FieldRow,
  List,
  ListItem,
  DeleteButton,
  Tag,
  ErrorText
} from './styles';

const MAX_NOME = 200;

const LinkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 13a5 5 0 007.07 0l2.83-2.83a5 5 0 10-7.07-7.07L10 5" stroke="#E52940" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 11a5 5 0 00-7.07 0L4.1 13.83a5 5 0 007.07 7.07L14 19" stroke="#E52940" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Badge = ({ children, showIcon = false }: { children: React.ReactNode, showIcon?: boolean }) => (
  <span style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    backgroundColor: 'var(--cfdf2f2)',
    color: 'var(--ce52940)',
    borderRadius: 9999,
    fontSize: '0.7rem',
    fontWeight: 700,
    marginLeft: 8
  }}>
    {showIcon && <LinkIcon />}
    {children}
  </span>
);

const PartesRepresentadas: React.FC<PartesRepresentadasProps> = ({
  representadas,
  autoRepresentadas,
  onAdd,
  onRemove,
  erros
}) => {
  const [nome, setNome] = useState('');
  const podeAdicionar = useMemo(() => nome.trim().length > 0, [nome]);

  const handleAdd = useCallback(() => {
    if (!podeAdicionar) return;
    onAdd(nome);
    setNome('');
  }, [podeAdicionar, onAdd, nome]);

  return (
    <div>
      <FieldRow>
        <div>
          <Input
            value={nome}
            placeholder="Digite o nome da parte representada"
            maxLength={MAX_NOME}
            onChange={e => setNome(e.target.value)}
          />
          {erros?.representadas?.nome && <ErrorText>{erros.representadas.nome}</ErrorText>}
        </div>
        <div>
          <AddButton
            disabled={!podeAdicionar}
            title={!podeAdicionar ? 'Preencha o nome da parte para adicioná-la' : ''}
            onClick={handleAdd}
          >
            + Adicionar
          </AddButton>
        </div>
      </FieldRow>

      <List style={{ marginTop: 12 }}>
        {representadas.map((nome) => {
          const vindaDeParte = autoRepresentadas.includes(nome);
          return (
            <ListItem key={nome}>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <span>{nome}</span>
                {vindaDeParte && <Badge showIcon={true}>Parte do Processo</Badge>}
              </div>
              <div>
                <DeleteButton onClick={() => onRemove(nome)}>
                  <IconTrash />
                </DeleteButton>
              </div>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default PartesRepresentadas;


